import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';  // новый импорт
import { getPageBySlug, getDocuments } from '../api';
import '../styles/SitePage.css';

const SitePage = ({ slug }) => {
  const [page, setPage] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      setError('Не указан идентификатор страницы');
      setLoading(false);
      return;
    }
    Promise.all([
      getPageBySlug(slug),
      slug === 'documents' ? getDocuments() : Promise.resolve([])
    ])
      .then(([pageData, docsData]) => {
        setPage(pageData);
        if (Array.isArray(docsData)) setDocuments(docsData);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setError('Страница не найдена');
        setLoading(false);
      });
  }, [slug]);

  if (loading) return <div className="loading-spinner">Загрузка...</div>;
  if (error) return <div className="error-message">{error}</div>;

  const getFileIcon = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    if (ext === 'pdf') return '📄';
    if (ext === 'doc' || ext === 'docx') return '📝';
    if (ext === 'xls' || ext === 'xlsx') return '📊';
    if (ext === 'txt') return '📃';
    return '📎';
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '—';
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(1)} КБ`;
    return `${(kb / 1024).toFixed(1)} МБ`;
  };

  return (
    <div className="site-page">
      <div className="container">
        <h1 className="page-title">{page.title}</h1>
        <div className="page-content" dangerouslySetInnerHTML={{ __html: page.content }} />

        {slug === 'documents' && (
          <div className="program-link-wrapper">
            <Link to="/program" className="program-link-btn">
              <span>Программа партии</span>
              <svg className="arrow-icon" viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
        )}

        {slug === 'documents' && documents.length > 0 && (
          <div className="documents-section">
            <h2>Документы отделения</h2>
            <div className="documents-grid">
              {documents.map(doc => (
                <div key={doc.id} className="document-card">
                  <div className="doc-icon">{getFileIcon(doc.original_name)}</div>
                  <div className="doc-info">
                    <h3>{doc.title}</h3>
                    <p className="doc-meta"> {formatFileSize(doc.size)}</p>
                    <a href={`http://localhost:5000${doc.file_path}`} target="_blank" rel="noopener noreferrer" className="btn-download">
                      Открыть/Скачать
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SitePage;